export default __webpack_public_path__ + "static/media/undraw_file_manager_re_ms29.2c93b97a.svg";